import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "as-scrolling as-scrolling__result-popup"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }

import { ref, computed } from "vue";
import type { ILineups, IMatch, IPlayer } from "~src/interfaces";
import SquadTab from "~src/components/lineups/SquadTab.vue";
import PlayerTeamTab from "~src/components/lineups/PlayerTeamTab.vue";
import PlayersTab from "~src/components/lineups/PlayersTab.vue";
import TabsBtn from "~src/components/TabsBtn.vue";
import { usecommonStore } from "~src/stores/CommonStore";

const __default__ = {};

interface IProps {
  lineups: ILineups;
  match: IMatch;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'LineupTab',
  props: {
    lineups: {},
    match: {}
  },
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;
const siteName = computed(() => commonStore.getSiteName);

const activeTab = ref("squad");

const tabs = [
  {
    title: "Sơ đồ",
    key: "squad",
  },
  {
    title: "Ra sân",
    key: "players",
  },
  {
    title: "Chấn thương & treo giò",
    key: "injuries_suspensions",
  },
];

const changeTab = (val: string) => {
  activeTab.value = val;
};

const startingPlayers = computed(() => {
  let result = [
    {
      type: "Starting Lineups",
      data: { home: <Array<IPlayer>>[], away: <Array<IPlayer>>[] },
    },
    { type: "Substitutes", data: { home: [], away: [] } },
    { type: "Injured or suspended", data: { home: [], away: [] } },
  ];
  try {
    let flag = false;
    try {
      const lineupSideHome = props.lineups?.lineup?.home || null;
      if (lineupSideHome) {
        for (const player of lineupSideHome) {
          if (player.first === 1) {
            result[0].data.home.push(player);
            flag = true;
          } else if ([-1, 2, 3].indexOf(player.first) === -1) {
            result[1].data.home.push(player);
            flag = true;
          }
        }
      }
      const lineupSideAway = props.lineups?.lineup?.away || null;
      if (lineupSideAway) {
        for (const player of lineupSideAway) {
          if (player.first === 1) {
            result[0].data.away.push(player);
            flag = true;
          } else if ([-1, 2, 3].indexOf(player.first) === -1) {
            result[1].data.away.push(player);
            flag = true;
          }
        }
      }

      if (props.lineups && props.lineups.id && props.lineups.injury.home) {
        result[2].data.home = props.lineups.injury.home;
        flag = true;
      }
      if (props.lineups && props.lineups.id && props.lineups.injury.away) {
        result[2].data.away = props.lineups.injury.away;
        flag = true;
      }
    } catch (e) {
      console.error(e);
    }
  } catch (error) {
    console.log(error);
  }

  return result;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-parent-lineups as-parent-lineups-${siteName.value}`)
  }, [
    _createVNode(TabsBtn, {
      tabs: tabs,
      activeTab: activeTab.value,
      onChange: changeTab,
      isShowBorder: true
    }, null, 8, ["activeTab"]),
    (_ctx.lineups)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (activeTab.value === 'squad')
            ? (_openBlock(), _createBlock(SquadTab, {
                key: 0,
                match: _ctx.match,
                lineups: _ctx.lineups,
                startingPlayers: startingPlayers.value[1].data
              }, null, 8, ["match", "lineups", "startingPlayers"]))
            : (activeTab.value === 'players')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createVNode(PlayerTeamTab, {
                    match: _ctx.match,
                    lineups: _ctx.lineups
                  }, null, 8, ["match", "lineups"]),
                  _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "as-h2-title-box" }, "ĐỘI HÌNH RA SÂN", -1)),
                  _createVNode(PlayersTab, {
                    match: _ctx.match,
                    lineups: _ctx.lineups,
                    startingPlayers: startingPlayers.value[0].data
                  }, null, 8, ["match", "lineups", "startingPlayers"]),
                  _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "as-h2-title-box" }, "Dự bị", -1)),
                  _createVNode(PlayersTab, {
                    match: _ctx.match,
                    lineups: _ctx.lineups,
                    startingPlayers: startingPlayers.value[1].data,
                    isSubstituted: true
                  }, null, 8, ["match", "lineups", "startingPlayers"])
                ]))
              : (activeTab.value === 'injuries_suspensions')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createVNode(PlayerTeamTab, {
                      match: _ctx.match,
                      lineups: _ctx.lineups
                    }, null, 8, ["match", "lineups"]),
                    _createVNode(PlayersTab, {
                      match: _ctx.match,
                      lineups: _ctx.lineups,
                      startingPlayers: startingPlayers.value[2].data,
                      isInjuredSuspended: true
                    }, null, 8, ["match", "lineups", "startingPlayers"])
                  ]))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})